module.exports = __webpack_public_path__ + "static/media/p16.5905a41d.jpeg";